<template lang="pug">

  v-form(ref="form" v-model="valid" lazy-validation)
    v-card
      v-card-title
        span.headline {{ $tc('department.title', 1) }}
        v-spacer
        v-btn(icon @click="close"): v-icon close
      v-card-text
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(xs12)
              v-text-field(
                v-model="name"
                :label="$t('department.name')"
                :rules="rules.name"
                :error-messages="errors.name"
              )
        v-simple-table(dense)
          template(v-slot:default)
            //- thead: tr
              th(width="60")
              th {{ $t('user.name') }}
            draggable(
              tag="tbody"
              handle=".dragHandle"
              v-model="users"
              @change="onDrop"
              )
              tr(v-for="user in users" :key="user.id")
                td.justify-center.layout.px-0
                  v-icon.mr-2.dragHandle(small style="cursor: move") drag_handle
                td {{ user.name }}

      v-card-actions
        v-menu(v-if="data.id" auto)
          template(v-slot:activator="{ on }")
            v-btn(color="red" text v-on="on") {{ $t('ui.delete') }}
          v-list.error
            v-list-item(@click="remove"): v-list-item-title {{ $t('ui.are_you_sure') }}
        v-btn(text @click="close") {{ $t('ui.cancel') }}
        v-spacer
        v-btn(color="blue" text :disabled="!valid" @click="submit") {{ $t('ui.save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Department from '../store/models/Department'
import draggable from 'vuedraggable'

export default{

  components: {
    draggable,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: true,
      name: '',
      rules: {
        name: [
          v => !!v || this.$t('validation.required', { field: this.$t('department.name') }),
        ],
      },
      errors: {},
      users: [],
    }
  },

  watch: {
    name() {
      this.errors.name = undefined
    },
  },

  beforeMount() {
    this.name = this.data.name
    this.users = this.data.workers.slice()
  },

  methods: {
    ...mapActions('entities/departments', {
      createItem: 'createItem',
      updateItem: 'updateItem',
      deleteItem: 'deleteItem',
    }),
    ...mapActions('entities/users', {
      setUsersOrder: 'setOrder',
    }),
    close() {
      this.$emit('close')
    },
    submit() {
      if(this.$refs.form.validate()) {
        const data = {
          ...this.data,
          name: this.name,
        }
        let promise
        if(this.data.id) promise = this.updateItem(data)
        else             promise = this.createItem(data)
        promise
          .then(response => this.$emit('close'))
          .catch(failed => this.errors = failed.errors || {})
      }
    },
    remove() {
      this.deleteItem(this.data).then(response => this.$emit('close'))
    },
    onDrop({ moved: { oldIndex, newIndex } }) {
      const data = {}
      let sort = 0
      this.users.forEach(user => data[user.id] = sort++)
      this.setUsersOrder(data).then(result => {
        // this.data.users = this.users
        Department.update({
          where: this.data.id,
          data: {
            workers: this.users
          }
        })
      })
    },
  },
}
</script>